import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import { connectState } from '@examdojo/angular/util';
import { LocalizedString, LocalizePipe } from '@examdojo/core/i18n';
import { MarkdownViewerComponent } from '@examdojo/ui/markdown-viewer';

@Component({
  selector: 'dojo-localized-markdown-string-cell-renderer',
  imports: [MarkdownViewerComponent, LocalizePipe, AsyncPipe],
  template: `
    @if (state.string && (state.string | localize | async); as string) {
      <div class="markdown-cell-renderer">
        <dojo-markdown-viewer style="display: flex" [content]="string ?? ''" />
      </div>
    }
  `,
  styles: [
    `
      .markdown-cell-renderer {
        @apply flex items-center justify-start;

        ::ng-deep markdown {
          @apply flex items-center justify-start;
        }
      }
    `,
  ],
})
export class LocalizedMarkdownStringCellRendererComponent extends BaseCellRendererComponent<LocalizedString> {
  readonly state = connectState({
    string: this.valueAsSingle$,
  });
}
